import axios from 'axios';
import { getApiBasePath } from '../config/apiBase';

const publicApi = axios.create({
  baseURL: getApiBasePath(),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

export default publicApi;
